<template>
  <div id="techcar">
    <v-container>
      <h1 class="mb-4 mt-20px">Techcar</h1>
      <v-card class="">
        <v-card-text class="pa-8">
          <v-row>
            <v-col>
              <p class="f18 mb-0 white100">Obhliadka</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                :value="miestoObhliadky"
                :label="'Miesto obhliadky'"
                class="dynamic-input-control required"
                :rules="[rules.required]"
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="kontaktnaOsoba"
                :label="'Kontaktná osoba k obhliadke'"
                class="dynamic-input-control required"
                :rules="[rules.required]"
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="telCislo"
                :label="'Tel. kontakt'"
                class="dynamic-input-control required"
                :rules="[rules.required]"
                outlined
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <p class="f18 mb-0 white100">Predmet financovania</p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                :value="farba"
                :label="'Farba'"
                class="dynamic-input-control"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="rokVyroby"
                :label="'Rok výroby'"
                class="dynamic-input-control"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="oznacenie"
                :label="'Označenie TP'"
                class="dynamic-input-control"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="mt-0">
            <v-col cols="4">
              <v-text-field
                :value="vin"
                :label="'VIN'"
                class="dynamic-input-control"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                :value="ecv"
                :label="'ŠPZ/EČV'"
                class="dynamic-input-control"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
          </v-row>
          <v-expansion-panels class="wizard-expansion-panels px-1 mb-5" flat v-model="expandPanel">
            <v-expansion-panel>
              <v-expansion-panel-header class="pa-0 mt-6">
                Dodatočné informácie
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="mt-2">
                  <v-col cols="4">
                    <v-text-field
                      :value="obchodnik"
                      :label="'Obchodník TL'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="emailObchodnik"
                      :label="'E-mail obchodníka'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="predmetFinanc"
                      :label="'Predmet financovania'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col cols="4">
                    <v-text-field
                      :value="obstarCenaBezDph"
                      :label="'Obstarávacia cena bez DPH'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="ostarCenaSDph"
                      :label="'Obstarávacia cena s DPH'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="pocetKm"
                      :label="'Počet kilometrov'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col cols="4">
                    <v-text-field
                      :value="ziadatel"
                      :label="'Žiadateľ o financovanie'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="dodavatel"
                      :label="'Dodávateľ vozidla'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="sposobFinanc"
                      :label="'Spôsob financovania (FL/SU/SP/OL)'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="mt-0">
                  <v-col cols="4">
                    <v-text-field
                      :value="akontacia"
                      :label="'Akontácia/vlastné zroje'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4">
                    <v-text-field
                      :value="tenor"
                      :label="'Doba splácania v mesiacoch'"
                      class="dynamic-input-control"
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
      <v-card class="mt-6">
        <v-card-text class="pa-8">
          <v-row>
            <v-col>
              <p class="f18 mb-0 white100">Prílohy</p>
              <span
                >Nahrajte tieto prílohy -
                <span style="font-weight: 700">Veľký technický preukaz</span> (povinné) a
                <span style="font-weight: 700">Kontrola originality</span> (nepovinné)</span
              >
            </v-col>
            <v-col cols="auto" class="ml-auto">
              <v-btn
                class="btn-secondary px-28px py-20px"
                density="default"
                variant="elevated"
                @click="uploadDokument = true"
              >
                <v-icon left> mdi-upload-outline </v-icon>
                Nahrať dokument
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-data-table
                ref="dokumentyRef"
                :headers="headers"
                :items="items"
                hide-default-footer
                :page.sync="page"
                :items-per-page="9"
                @page-count="pageCount = $event"
                item-key="id_dokumentu"
                :loading="loading"
                loadingText="Načítavam dáta ..."
              >
                <template v-slot:[`item.poznamka`]="{ item }">
                  <div class="text-overflow-dots">{{ item.poznamka }}</div>
                </template>

                <template v-slot:[`item.datum_modifikacie`]="{ item }">
                  {{ item.datum_modifikacie ? item.datum_modifikacie.formatDate() : '' }}
                </template>

                <template v-slot:[`item.akcie`]="{ item }">
                  <v-menu
                    content-class=""
                    transition="slide-x-transition"
                    offset-x
                    left
                    close-delay="100"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn dark icon v-bind="attrs" v-on="loadMenuDokumentu(item, on)">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>

                    <v-list elevation="1">
                      <v-list-item
                        link
                        dense
                        v-for="(m, i) in item.menu"
                        :key="i"
                        :class="m.color"
                        :disabled="!m.isEnabled"
                        @click="actionClick(m, item)"
                      >
                        <v-list-item-icon class="mr-4">
                          <v-icon
                            v-text="m.icon"
                            class="material-icons-outlined icon-block"
                            size="24"
                          ></v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ m.nazov }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      miestoObhliadky: '',
      kontaktnaOsoba: '',
      telCislo: '',
      rules: {
        required: value => {
          return !!value || value === 0 || 'Povinné pole';
        },
      },
      expandPanel: null,
      obchodnik: '',
      emailObchodnik: '',
      predmetFinanc: '',
      obstarCenaBezDph: '',
      ostarCenaSDph: '',
      pocetKm: '',
      ziadatel: '',
      dodavatel: '',
      sposobFinanc: '',
      akontacia: '',
      tenor: '',
      farba: '',
      rokVyroby: '',
      oznacenie: '',
      vin: '',
      ecv: '',
      loading: false,
      page: 0,
      items: [],
      headers: [
        { text: 'Názov dokumentu', value: 'nazov' },
        { text: 'Modifikované', value: 'datum_modifikacie' },
        { text: 'Poznámka', value: 'poznamka' },
        { text: 'Akcie', value: 'akcie', sortable: false },
      ],
    };
  },
};
</script>
